<script>
  export let showLegend = false;
</script>
<div class="year-legend">
  {#if showLegend}
    <legend>Year</legend>
  {/if}
  <ul>
    <li>
        <span class="year-legend__current"></span>
        <span>2025</span>
    </li>
    <li>
        <span class="year-legend__past"></span>
        <span>2020</span>
    </li>
  </ul>
</div>
